<template>
  <div>

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        유저
      </h2>

      <div class="link_location">
        설정 <v-icon small class="mdi mdi-chevron-right" />
        일반설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/Encoding-Server">유저 정보</a>
      </div>
    </div>

    <v-row>
      <v-col cols="5">
        <SearchTextfield v-model="searchQuery" placeholder="사용자 이름 사용자 찾기" />
      </v-col>

      <v-col class="text-right mb-2">
        <IconButton icon="mdi-refresh" class="mr-2" @click="refresh" small/>
        <router-link to="/admin/user_create">
          <IconTextButton icon="mdi-folder-plus-outline" buttonText="유저 추가" class="mr-2" default="outlined" />
        </router-link>

        <IconButton icon="mdi-trash-can-outline" :disabled="selected.length === 0" @click="userDelete" class="mr-2" small/>

        <!--delete dialog-->
        <!-- <template>
          <v-dialog v-model="deleteDialog" persistent max-width="580">

            <template v-slot:activator="{ on, attrs }">

              <IconButton icon="mdi-trash-can-outline" v-bind="attrs" v-on="on" />

            </template>
<v-card class="pa-3">
  <v-card-title class="text-h5 mb-3">
    Delete selected user id?
  </v-card-title>
  <v-card-text>
    <v-row>
      <v-col>
        <strong>User ID : {{ adminsIds }} </strong>permanently? This will also delete all its users.
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        This action cannot be undone.
      </v-col>
    </v-row>

    <v-row style="margin-top: -18px;">
      <v-col>
        {{ adminsIds }}
      </v-col>
    </v-row>

    <v-divider class="pa-5 mt-4 mb-0" />

    <v-row style="margin-top: -28px;">
      <v-col>
        To confirm deletion. enter 'delete' in the text input field.'
      </v-col>
    </v-row>
    <v-row style="margin-top: -36px;">
      <v-col>
        <v-text-field label="DELETE" single-line hide-details color="black" v-model="deleteStr"
          @input="checkStr"></v-text-field>
      </v-col>
    </v-row>

  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn outlined elevation="0" @click="deleteDialog = false">
      취소
    </v-btn>
    <v-btn outlined elevation="0" @click="deleteAdmin" :loading="loadingDelete" :disabled="disabledDelete">
      삭제
    </v-btn>
  </v-card-actions>
</v-card>
</v-dialog>
</template> -->

      </v-col>


    </v-row>

    <!--table card-->

    <v-data-table :items="admins" :headers="headers" :items-per-page="10" :search="searchQuery" :key="admins.id"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" :loading="loading"
      class="data-table" :disable-sort="true" show-select v-model="selected">

      <template v-slot:item.testurl="{ item }">
        <v-btn dark elevation="0" small @click="getInfo(item)">
          정보
        </v-btn>
      </template>

    </v-data-table>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    <!--end-->
  </div>
</template>

<script>
//import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import SearchTextfield from '@/components/app/AppSearchField.vue';
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import { mapState } from 'vuex';
import UserApi from "@/api/user/UserApi";
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";

export default {
  components: {
    SearchTextfield,
    IconButton,
    IconTextButton,
    AppSnackbar
  },
  computed: {
    ...mapState('search', ['searchQuery']),
  },
  data() {
    return {
      headers: [
        { text: '이름', value: 'name' },
        { text: '이메일', value: 'email' },
        { text: '상세 정보', value: 'testurl' },
      ],
      selected: [],
      search: '',
      loading: false,
      admins: [],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',

    }
  },
  mounted() {
    this.userList();
  },
  methods: {
    async userList() {
      try {
        //this.loading = true;
        const response = await UserApi.listApi();
        //this.loading = false;
        this.admins = response.userlist;
      } catch (error) {
        console.error('error', error);
      }
    },
    async userDelete() {
      if (this.selected.length > 0) {
        const frontUrl = `${window.location.protocol}//${window.location.host}`;
        const data = {
          ids: this.selected.map(server => server.id),
          ip: frontUrl,
        };
        try {
          const response = await UserApi.deleteApi(data);
          console.log('res => ', response);
          if (response.status === 1) {
            setTimeout(() => {
                this.snackbar = true;
                this.snackbarText = '삭제 성공';
                this.snackbarError = false;
                setTimeout(() => {
                  this.selected = [];
                  this.userList();
                  this.snackbar = false;
                }, 2000);
            }, 1000);
          } else {
            setTimeout(() => {
                this.snackbar = true;
                this.snackbarError = true;
                this.snackbarText = '삭제 실패';
                setTimeout(() => {
                  this.selected = [];
                  this.userList();
                  this.snackbar = false;
                }, 2000);
            }, 1000);
          }
        } catch (error) {
          console.error('errorr', error);
        }
      } else {
        console.log('error');
      }
    },
    refresh() {
      this.userList();
    },
    getInfo(item) {
      this.$router.push({ path: '/admin/user_details/' + item.id });
    },
  }
}
</script>

<style lang="scss" scoped></style>